import { FC } from "react";
import { IShotHistory } from "../../types";
import SectionCard from "./SectionCard";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { History } from "@mui/icons-material";
import moment from "moment";

interface ShotHistorySectionProps {
  shotHistory?: IShotHistory[];
  totalShots: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => void;
  onRowsPerPageChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  isLoading: boolean;
  translate: (key: string) => string;
}

const ShotHistorySection: FC<ShotHistorySectionProps> = ({
  shotHistory,
  totalShots,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  translate,
}) => (
  <SectionCard
    title="Histórico de Disparos"
    icon={<History />}
    isLoading={isLoading}
  >
    {shotHistory && shotHistory.length > 0 ? (
      <>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">Posição</TableCell>
                <TableCell>Serial do Cartucho</TableCell>
                <TableCell>Fragrância</TableCell>
                <TableCell>Configuração</TableCell>
                <TableCell align="center">Disparos Realizados</TableCell>
                <TableCell>Data do Disparo</TableCell>
                <TableCell align="center">Restantes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shotHistory.map(shot => (
                <TableRow
                  key={shot.miniscentShotHistoryId}
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Chip
                      label={shot.position}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>{shot.cartridgeSerialNumber}</TableCell>
                  <TableCell>
                    {shot.fragrance?.name || `ID: ${shot.fragranceId}`}
                  </TableCell>
                  <TableCell>
                    {shot.campaign?.name || `ID: ${shot.campaignId}`}
                  </TableCell>
                  <TableCell align="center">{shot.shotsPerformed}</TableCell>
                  <TableCell>
                    {moment(shot.shotAt).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={shot.shotsRemaining}
                      color={
                        shot.shotsRemaining > 50
                          ? "success"
                          : shot.shotsRemaining > 10
                          ? "warning"
                          : "error"
                      }
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalShots}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Itens por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      </>
    ) : (
      <Typography color="text.secondary" align="center">
        Nenhum disparo registrado
      </Typography>
    )}
  </SectionCard>
);

export default ShotHistorySection;
